module.exports = __webpack_public_path__ + "img/icon_approve_reduce.d2e9d768.png";